// /app/modules/frugal/ui/components/ItemMenu.jsx
// Dropdown menu for item actions (70 lines)

import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { MoreVertical, Pencil, Trash2 } from 'lucide-react';

const ItemMenu = ({ onEdit, onDelete, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) &&
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleToggle = () => {
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const openUpward = spaceBelow < 120;
      
      setMenuPosition({
        top: openUpward ? rect.top - 90 : rect.bottom + 4,
        left: rect.right - 130 // Align right edge with button
      });
    }
    setIsOpen(!isOpen);
  };

  const menuContent = isOpen && createPortal(
    <div 
      ref={menuRef}
      className="fixed bg-slate-800 border border-white/10 rounded-lg shadow-xl min-w-32"
      style={{ 
        top: menuPosition.top, 
        left: menuPosition.left,
        zIndex: 9999 
      }}
    >
      <button
        onClick={() => { onEdit(); setIsOpen(false); }}
        className="w-full flex items-center gap-2 px-3 py-2 text-sm text-blue-400 hover:bg-white/5 transition-colors"
      >
        <Pencil className="w-4 h-4" />
        {t('frugal.expenses.edit')}
      </button>
      <button
        onClick={() => { onDelete(); setIsOpen(false); }}
        className="w-full flex items-center gap-2 px-3 py-2 text-sm text-rose-400 hover:bg-white/5 transition-colors"
      >
        <Trash2 className="w-4 h-4" />
        {t('frugal.expenses.delete')}
      </button>
    </div>,
    document.body
  );

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={handleToggle}
        className="p-1 rounded hover:bg-white/10 text-slate-400 hover:text-white transition-colors"
        data-testid="item-menu-button"
      >
        <MoreVertical className="w-4 h-4" />
      </button>
      {menuContent}
    </div>
  );
};

export default ItemMenu;
